module.exports = __webpack_public_path__ + "static/media/adok_start.7e9f033f.png";